import * as React from 'react';

const LinkedInLogo: React.FC = () => {
  return (
    <svg
      width="150"
      height="161"
      viewBox="0 0 150 161"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z"
        fill="#CAE6ED"
      />
      <g filter="url(#filter0_d_630:6869)">
        <path
          d="M118 43H32C29.2386 43 27 45.2386 27 48V153C27 155.761 29.2386 158 32 158H118C120.761 158 123 155.761 123 153V48C123 45.2386 120.761 43 118 43Z"
          fill="white"
        />
      </g>
      <path
        d="M53 134C55.2091 134 57 132.209 57 130C57 127.791 55.2091 126 53 126C50.7909 126 49 127.791 49 130C49 132.209 50.7909 134 53 134Z"
        fill="#CBE4EC"
      />
      <path
        d="M75 134C77.2091 134 79 132.209 79 130C79 127.791 77.2091 126 75 126C72.7909 126 71 127.791 71 130C71 132.209 72.7909 134 75 134Z"
        fill="#4C8EA1"
      />
      <path
        d="M97 134C99.2091 134 101 132.209 101 130C101 127.791 99.2091 126 97 126C94.7909 126 93 127.791 93 130C93 132.209 94.7909 134 97 134Z"
        fill="#CBE4EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.7688 68.1667C54.884 68.1667 54.1667 68.8839 54.1667 69.7687V108.231C54.1667 109.116 54.884 109.833 55.7688 109.833H94.2313C95.1161 109.833 95.8334 109.116 95.8334 108.231V69.7687C95.8334 68.8839 95.1161 68.1667 94.2313 68.1667H55.7688ZM82.9748 102.826H89.375V92.8817C89.375 87.3425 86.2234 84.7701 82.212 84.7701C78.9787 84.7701 76.9526 86.5216 76.578 87.7488V84.942H70.2374C70.3192 86.4322 70.2374 102.826 70.2374 102.826H76.578V93.1481C76.578 93.0838 76.5777 93.0195 76.5773 92.9555V92.9555C76.5746 92.4839 76.572 92.0265 76.7159 91.6866C77.1518 90.6111 78.0883 89.4951 79.7722 89.4951C81.9737 89.4951 82.9748 91.1488 82.9748 93.5712V102.826ZM63.8253 82.7051H63.7845C61.7413 82.7051 60.4167 81.338 60.4167 79.6051C60.4167 77.8385 61.7805 76.5 63.8645 76.5C65.9468 76.5 67.2272 77.8351 67.268 79.6C67.268 81.3329 65.9468 82.7051 63.8253 82.7051ZM66.7913 84.942H61.1471V102.826H66.7913V84.942Z"
        fill="#4C8EA1"
      />
      <rect
        opacity="0.01"
        x="50"
        y="64"
        width="50"
        height="50"
        fill="#4C8EA1"
      />
      <circle cx="122.5" cy="44.5" r="12.5" fill="#4C8EA1" />
      <path
        d="M120.5 46.6895L118.03 44.2198L116.97 45.2803L120.5 48.8105L127.78 41.5303L126.72 40.4698L120.5 46.6895Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_630:6869"
          x="21"
          y="34"
          width="108"
          height="127"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_630:6869"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_630:6869"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LinkedInLogo;
